import { useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { resolveRedirect } from "@/data/redirects";
import { reportRedirectHit } from "@/utils/redirectHit";

/**
 * Mount this at the top of <Routes> as `<Route path="*" element={<LegacyRedirectsGate />} />`
 * if you want every unmatched URL to first consult the redirect map. We instead
 * wrap it as a wildcard child of the public layout so it runs BEFORE the 404 page.
 *
 * If the current URL has a mapped redirect target, we navigate to it with
 * `replace` (no history entry). Otherwise we render the provided `fallback`
 * (typically the <NotFoundPage />).
 */
export const LegacyRedirectsGate = ({ fallback }) => {
  const { pathname, search, hash } = useLocation();
  const target = resolveRedirect(pathname);

  useEffect(() => {
    if (target) reportRedirectHit(pathname, target);
  }, [pathname, target]);

  if (target) {
    return <Navigate to={`${target}${search || ""}${hash || ""}`} replace />;
  }
  return fallback;
};
